import { el, mount, unmount } from 'redom';

import './index.scss';

class FullscreenBanner {

  constructor(configuration) {

    this.prompts = configuration.prompts;
    this.message = configuration.message;

    this.el = el('#fullscreen-banner-main', [
      el('#fullscreen-banner-content', [
        el('label', this.message),
        el('ht-spinner', { size: 'small' })
      ])
    ]);

    mount(this.prompts.promptsContainer, this.el);

  }

  destroy() {

    unmount(this.prompts.promptsContainer, this.el);

  }

}

export default FullscreenBanner;